module.exports = __webpack_public_path__ + "img/credential4.1e87c834.png";